import { ReactNode, useState } from 'react'
import { SustainabilityHeaderSlotContext } from './SustainabilityHeaderSlotContext'

// Provider component to wrap the application
export function SustainabilityHeaderSlotProvider({
    children,
}: {
    children: ReactNode
}) {
    const [slot, setSlot] = useState<ReactNode>(null)

    return (
        <SustainabilityHeaderSlotContext.Provider value={{ slot, setSlot }}>
            {children}
        </SustainabilityHeaderSlotContext.Provider>
    )
}
